export default {
  products: [],
  product: {},
  credit: []
};
